const uspMobile = {
  type: 'Usp',
  props: {
    display: ['block', null, 'none'],
    my: [4, null, 0],
    title: 'Onze experts hebben het beste met je voor:',
    items: [
      'Vind een onafhankelijk en betrouwbaar advies',
      'Kies uit een compleet aanbod',
      'Sluit direct af',
      'Krijg snel een duidelijk overzicht',
      'Consumenten geven ons een 8,4',
    ],
    iconVerticalAlignment: 'start',
  },
};

export default uspMobile;
